class CntrlPlusCartFlow {
  constructor() {
    const { starterKitProductId } = document.documentElement.dataset;

    this.starterKitProductId = starterKitProductId
      ? parseInt(starterKitProductId)
      : null;
    this.routes = window.theme.routes || {};
    this.paths = {
      base: `${this.routes.cart.base || "/cart"}.js`,
      change: `${this.routes.cart.change || "/cart/change"}.js`,
    };

    if (this.starterKitProductId) {
      this.initStarterKitEnforcement();
    }
  }

  initStarterKitEnforcement() {
    document.addEventListener("cart:changed", (evt) => {
      this.enforceStarterKitLimit(evt.detail.cartData);
      this.updateStarterKitButton(evt.detail.cartData);

      // Re-apply after button animation completes (~1.8s) to ensure
      // the state persists for all users regardless of login status
      setTimeout(() => {
        this.updateStarterKitButton(evt.detail.cartData);
      }, 2000);
    });

    document.addEventListener("cart:item-added", (evt) => {
      this.updateStarterKitButton(evt.detail.cartData);
    });
  }

  enforceStarterKitLimit(cartData) {
    const { items } = cartData;
    if (!items || !items.length) return;

    const starterKitItem = items.find(
      (item) => item.product_id === this.starterKitProductId
    );

    if (starterKitItem && starterKitItem.quantity > 1) {
      this.changeItemQuantity(starterKitItem.key, 1);
    }
  }

  updateStarterKitButton(cartData) {
    const buttonWrapper = document.querySelector("[data-starter-kit-button]");
    if (!buttonWrapper) return;

    const button = buttonWrapper.querySelector("[js-button-with-state]");
    if (!button) return;

    const items = cartData.items || [];
    const inCart = items.some((item) => item.product_id === this.starterKitProductId);

    const addToCartLabel = window.theme.strings?.cart?.addToCart || "Add to cart";
    const limitLabel = "Limit 1 per customer";
    const newLabel = inCart ? limitLabel : addToCartLabel;

    button.disabled = inCart;

    button.querySelectorAll(
      ".label-idle__inner, .label-default, .button-with-state__label--hidden"
    ).forEach((el) => {
      el.textContent = newLabel;
    });
  }

  changeItemQuantity(id, quantity) {
    const fetchData = {
      id: `${id}`,
      quantity,
    };

    return fetch(this.paths.change, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(fetchData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422) {
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: { errorMessage: data.description },
            })
          );
        } else {
          this._emitEvent(data);
        }
      });
  }

  _emitEvent(cartData) {
    const eventOptions = {
      detail: { cartData },
      bubbles: true,
    };

    document.dispatchEvent(new CustomEvent("cart:item-changed", eventOptions));
    document.dispatchEvent(new CustomEvent("cart:changed", eventOptions));
  }
}

new CntrlPlusCartFlow();
